var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.contentObj ? _c('span', [_c('div', {
    staticClass: "mobile-w-100 more-info-container"
  }, [_c('a', {
    staticClass: "mobile-on mobile-lefted-2",
    on: {
      "click": function ($event) {
        return _vm.$router.back();
      }
    }
  }, [_c('div', {
    staticClass: "mobile-back-btn Arrow-Macro"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "mobile-profile-sub-header"
  }, [_vm._v("\n        " + _vm._s(_vm.contentObj.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 campaign-content",
    domProps: {
      "innerHTML": _vm._s(_vm.contentObj.content)
    }
  })])])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }